import type { AttackKind, Intent } from './simulation'

export const ATTACK_BUFFER_WINDOW = 0.12

export function attackEdge(current: Intent, previous: Intent): AttackKind | null {
  if (current.special && !previous.special) return 'special'
  if (current.throw && !previous.throw) return 'throw'
  if (current.heavy && !previous.heavy) return 'heavy'
  if (current.light && !previous.light) return 'light'
  return null
}

export function attackIntent(base: Intent, kind: AttackKind | null): Intent {
  return {
    ...base,
    light: kind === 'light',
    heavy: kind === 'heavy',
    special: kind === 'special',
    throw: kind === 'throw',
  }
}

export function decayBuffer(timer: number, dt: number) {
  if (!Number.isFinite(timer) || timer < 0) throw new RangeError('Input buffer timer must be finite and non-negative')
  if (!Number.isFinite(dt) || dt < 0) throw new RangeError('Input buffer frame delta must be finite and non-negative')
  return Math.max(0, timer - dt)
}
